
//Derived from C:\BITBUCKET\ACEP\Acep.Crm\XrmEntities\GlobalConstants.cs


export enum MembershipOrganization {
    NONE = -1,
    ACEP = 1,
    EMRA = 2,
    SEMPA = 3
}

export enum ACEPMembershipStatus {
    None = -1,
    Active = 1,
    ActiveStaff = 2,
    Applicant = 3,
    Cancelled = 4,
    TerminatedStaff = 7
}

export enum EMRAMembershipStatus {
    None = -1,
    Active = 8,
    Applicant = 10,
    Cancelled = 11,
}

export enum SEMPAMembershipStatus {
    None = -1,
    Active = 15,
    Applicant = 16,
    NonMember = 19,
    Cancelled = 21
}

export enum MembershipStatusReason {
    None = -1,
    DeclinedInstallments = 1,
    NewMember = 2,
    Reinstatement = 3,
    ReinstatementWNMO = 5,
    Renewal = 7,
    RenewalPP = 8,
    Restart = 9,
    ChapterStaff = 10,
    Staff = 11,
    StaffMailAuditors = 12,
    VIPNonACEP = 13,
    AppGroupInvoice = 14,
    GroupInvAppRecdNoInv = 17,
    GroupInvecdNoApp = 18,
    IncompleteApp = 19,
    MastInvRecdNoApp = 20,
    MastInvAppRecdNo = 21,
    MasterInvoice = 22,
    RestartAppIncomplete = 23,
    AppIneligible = 26,
    AppResigned = 28,
    Deceased = 29,
    DuplicateRecord = 30,
    Ineligible = 32,
    LostContact = 33,
    NonACEP = 34,
    NonPayment = 35,
    Resigned = 36,
    TerminatedChapterStaff = 37,
    TerminatedStaff = 38,
    TerminatedVIPNonACEP = 40,
    PaymentPending = 41,
    Complimentary = 42,
    Applicant = 44,
    Faculty = 45
}

export enum ACEPMembershipType {
    None = -1,
    Regular = 1,
    Candidate = 2,
    Honorary = 3,
    International = 5
}

export enum EMRAMembershipType {
    None = -1,
    Active = 7,
    Alumni = 8,
    Honorary = 9,
    Inactive = 10,
    International = 11,
    Life = 12
}

export enum SEMPAMembershipType {
    None = -1,
    Assoc = 13,
    Fellow = 14,
    Life = 15,
    Resident = 16,
    Student = 17,
    Graduate = 19,
    NPResident = 20
}

export enum MembershipRate {
    None = -1,
    Regular = 1,
    RegYR1 = 2,
    RegYR2 = 3,
    RegYR3 = 4,
    MilYR1 = 5,
    MilYR2 = 6,
    NewMemb = 7,
    NewYR1 = 8,
    NewYR2 = 9,
    NewYR3 = 10,
    RegPPre = 11,
    CnIntern = 15,
    CnMedStu = 16,
    CnResi = 17,
    Fellow = 18,
    GMOYR1 = 19,
    GMOYR2 = 20,
    GMOYR3 = 21,
    GMOYR4 = 22,
    IntIntrn = 23,
    IntMedSt = 24,
    IntResi = 25,
    Intern = 26,
    MedStu = 27,
    Resident = 28,
    Honorary = 29,
    Inactive = 30,
    InExtend = 31,
    Canada = 32,
    CnIFEM = 33,
    CnYR1 = 34,
    CnYR2 = 35,
    IntCSAGB = 36,
    IntIFEM = 37,
    Intnatl = 38,
    IntYR1 = 39,
    Life = 40,
    RegHonor = 42,
    LifePPre = 43,
    LifeRet = 44,
    Wiegnstn = 45,
    RetInact = 46,
    CnFellw = 49,
    Rupke = 50,
    Alumni = 51,
    InGMO = 52,
    Flw1YR = 53,
    Flw2YR = 54,
    Student = 55,
    Assoc1YR = 56,
    Assoc2YR = 57,
    Life1YR = 58,
    SrFlw1YR = 59,
    SrFlw2YR = 60,
    DpFlw1YR = 61,
    DpFlw2YR = 62,
    DpLfe1YR = 63,
    IntFellw = 65,
    LifeCn = 67,
    LifeIn = 68,
    Life06 = 69,
    LifeCn06 = 70,
    LifeIn06 = 71,
    Life09 = 72,
    LifeCn09 = 73,
    LifeIn09 = 74,
    Life13 = 75,
    LifeCn13 = 76,
    LifeIn13 = 77,
    CnRet = 78,
    RegInact = 80,
    CanInact = 81,
    CnInact = 82,
    IntInact = 83,
    RegRet = 84,
    Mil1YR = 85,
    Graduate = 93,
    NPResi = 94
}

//export enum OrderWebSource
//{
//    None                        = -1,
//    ACEPGroupPortallication       = 1,
//    ACEPMemberDues              = 2,
//    SEMPAGroupPortallication      = 3,
//    SEMPAMemberDues             = 4,
//    SectionApplication          = 5,
//    ChapterApplication          = 6,
//    EMRAGroupPortallication       = 7,
//    SectionsSubscriptionApplication = 8,
//    MeetingsRegistration        =9
//}

export enum OrderStatus {
    None = -1,
    New = 1,
    Pending = 2,
    Submitted = 3,
    Canceled = 4,
    Invoiced = 5,
    NeedsReview = 200000
}

export enum GradPostGrad {
    None = -1,
    Graduation = 1,
    PostGraduation = 2
}

export enum ContactEmploymentStatus {
    None = -1,
    IndependentContractor = 1,
    EmployedByHospital = 2,
    EmployedByUniversity = 3,
    EmployedByPhysicianGroup = 4,
    EmployedByGovernment = 5,
    Retired = 6,
    Other = 7
}

export enum InstitutionType {
    None = -1,
    MedicalSchool = 1000,
    Internship = 2000,
    Residency = 3000,
    PAProgram = 4000,
    PGProgram = 5000
}

export enum ResidencyPosition {
    None = -1,
    Resident = 1,
    Other = 2,
    Intern = 3
}

export enum CareerStatusACEP {
    None = -1,
    MedicalStudent = 1,
    Intern = 2,
    Resident = 3,
    Fellow = 4,
    AcademicPhysician = 5,
    AttendingPhysician = 6
}

export enum CareerStatusSEMPA {
    None = -1,
    Fellow = 1,
    Associate = 2,
    Student = 3,
    Resident = 4,
}

// On Contact entity
export enum CurrentBillToCode {
    Individual = 1,
    Group = 2,
    Residency = 3
}

export enum WebInstallmentCode {
    Monthly = 12,
    Quarterly = 4,
    SemiAnnual = 2,
    Annual = 1
}

export enum BillingOptionPaymentStatus {
    Pending = 1,
    Succeeded = 2,
    Failed = 3
}

export enum BillingOptionType {
    Subscription = 1,
    Membership = 2,
    Contribution = 3
}

export enum OrderSource {
    None = -1,
    CRM = 1,    // this is default set in CRM
    Admin = 2,
    Web = 3
}

/// <summary>
/// Ordertypecode replaces ordersourcecode - rsangra 12/4/2014
/// Use description attribute to add string with spaces. ExtensionHelper.GetEnumDescription will get the description(if present) or the string
/// Add new enumeration at end to avoid any index or position issue
/// </summary>
export enum OrderTypeCode {
    Contribution = 1,
    eCME = 2,
    MeetingRegistration = 3,
    ////[Description("Membership - Group")]
    MembershipGroup = 4,
    ////[Description("Membership - Individual")]
    MembershipIndividual = 5,
    Subscription = 6,
    // //[Description("CME Approval")]
    CMEApproval = 7,
    CUAP = 8,
    Section = 9,
    SectionSubscription = 10,
    FACEP = 11,
    Chapter = 12,
    EDUPROD = 13,
    CEDR = 14
}

/// <summary>
/// Holds the values same as the Obsolete OrderWebSourceCode attribute of the Sales Order Entity
/// </summary>
export enum OrderWebSourceCode {
    None = 0,
    ACEPGroupPortallication = 1,
    ACEPMemberDues = 2,
    SEMPAGroupPortallication = 3,
    SEMPAMemberDues = 4,
    SectionApplication = 5,
    ChapterApplication = 6,
    EMRAGroupPortallication = 7,
    SectionSubscriptionApplication = 8,
    MeetingRegistration = 9,
    Vendor = 10,
    EMRAMemberDues = 11,
    ECME = 12,
    CUAP = 13
}

export enum OrderOrganizationCode {
    None = -1,
    ACEP = 1,
    EMRA = 2,
    ACEPEMRA = 3,
    SEMPA = 4,
    EMF = 5,
    NEMPAC = 6
}

export enum OrderStatusReason {
    New = 1,
    Pending = 2,
    InProgress = 3,
    VoidedTransaction = 4,
    Complete = 100001,
    Partial = 100002,
    Invoiced = 100003,
    NeedReview = 200000,
}

/// <summary>
/// map to cashReceipt.Acep_PaymentTypeCode
/// </summary>
export enum PaymentType {
    None = -1,
    CashDeposit = 1,
    CheckDeposit = 2,
    CreditCardDeposit = 3,
    CashPayment = 4,
    CheckPayment = 5,
    CreditCardPayment = 6,
    GiftCard = 7,
    TravellersCheck = 8,
    Other = 9
}

export enum SalesOrderStatus {
    None = -1,
    New = 1,
    Pending = 2,
    NeedReview = 200000,
    InProgress = 3,
    VoidedTransaction = 4,
    Complete = 100001,
    Partial = 100002,
    Invoiced = 100003
}

export enum ProcessJobAction {
    Create = 430890000,
    Delete = 430890002,
    Grant = 430890003,
    Update = 430890001,
    Revoke = 430890004
}

export enum ProcessJobEntityType {
    Account = 430890000,
    Contact = 430890001
}

export enum ProcessJobIntegrationStatus {
    Error = 430890000,
    Pending = 430890001,
    Processed = 430890002,
    Retry = 430890003,
    Overriden = 430890004
}

export enum ProductType {
    //[Description("Sales Inventory")]
    SalesInventory = 1,
    //[Description("Miscellaneous Charges")]
    MiscellaneousCharges = 2,
    Services = 3,
    //[Description("Flat Fees")]
    FlatFees = 4,
    Membership = 200000,
    Event = 200001,
    CME = 200002
}
export enum ProductSubType {
    //[Description("Chapter Dues")]
    ChapterDues = 1,
    //[Description("EMF")]
    EMF = 2,
    //[Description("National Dues")]
    NationalDues = 3,
    NEMPAC = 4,
    PAC = 5,
    SECT = 6,
    SPEC = 7,
    EventReg = 8,
    EventSpecFunc = 9,
    EventLab = 10,
    EventResearch = 11,
    EventExhibit = 12,
    EventBooth = 13,
    EventCME = 14,
    Fee = 15,
    EventTotals = 16,
    //[Description("ACEP APLS")]
    ACEPAPLS = 17,
    //[Description("ACEP Retro")]
    ACEPRetro = 18,
    //[Description("ACEP Series")]
    ACEPSeries = 19,
    //[Description("ACEP LiveAct")]
    ACEPLiveAct = 20,
    //[Description("ACEP EndMat")]
    ACEPEndMat = 21,
    //[Description("AMA ChpLiveAct")]
    AMAChpLiveAct = 22,
    //[Description("AMA ChpLiveOcc")]
    AMAChpLiveOcc = 23,
    //[Description("AMA 3rdLiveAct")]
    AMA3rdLiveAct = 24,
    //[Description("AMA 3rdLiveOcc")]
    AMA3rdLiveOcc = 25,
    //[Description("AMA ChpEndMat")]
    AMAChpEndMat = 26,
    //[Description("AMA 3rdEndMat")]
    AMA3rdEndMat = 27,
    //[Description("AMA RushFee")]
    AMARushFee = 28,
    EventFunc = 29,
    //[Description("ACEP RushFee")]
    ACEPRushFee = 30,
    //[Description("AMA 10Per")]
    AMA10Per = 31,
    //[Description("Section Subscription")]
    SectionSubscription = 32
}

export enum QuestionnaireContactStatusReason {
    Active = 1,
    Inactive = 2,
    Pending = 430890000
}

export enum SubscriptionStatus {
    New = 1,
    Renewal = 2,
    Reinstatement = 5,
    Continued = 6,
    Cancelled = 4,
    Expired = 3
}